import posthog from "posthog-js"
import { format, isSameYear } from "date-fns"
import type { DocumentLink } from "@/reducers/messagesSlice"

export const GPS_DOCUMENT_LINKS_FLAG = "gps-document-links"
const CMR_DELIVERY_LINK_FLAG = "cmr-delivery-link"

/**
 * Accounts whose document links come from GPS. Their CMR report is read-only:
 * no manual link/unlink and no "Processed" status. chomar.pl always keeps its
 * wizard-produced links, even if the flag is turned on by mistake.
 */
export const isGpsDocumentLinksAccount = (
  host: string | undefined,
  flagEnabled: boolean | undefined = posthog.isFeatureEnabled(
    GPS_DOCUMENT_LINKS_FLAG,
  ),
) => flagEnabled === true && !!host && host.toLowerCase() !== "chomar.pl"

/** Manual link/unlink writes wizard stanzas, so GPS accounts never get it. */
export const isManualDocumentLinkingEnabled = (host: string | undefined) =>
  posthog.isFeatureEnabled(CMR_DELIVERY_LINK_FLAG) === true &&
  !isGpsDocumentLinksAccount(host)

/** "TransportAccompanyingDocument" → "Transport Accompanying Document" */
export const humanizeDocumentType = (type: string | undefined) =>
  type?.replace(/([a-z])([A-Z])/g, "$1 $2") ?? ""

/**
 * GPS document file names are upload hashes, so name a document by its type
 * and send time instead, e.g. "CMR · 24.10 16:16". No comma inside, because
 * chat lists these labels comma-separated.
 */
export const gpsDocumentLabel = (
  link: Pick<DocumentLink, "cmrDocumentType" | "timestamp">,
  sentAt: string = link.timestamp,
) => {
  const date = new Date(sentAt)
  const time = format(
    date,
    isSameYear(date, new Date()) ? "dd.MM HH:mm" : "dd.MM.yyyy HH:mm",
  )
  const type = humanizeDocumentType(link.cmrDocumentType)
  return type ? `${type} · ${time}` : time
}
